import type { ViewProps } from 'react-native'
import * as Comp from './coachmark-wrapper.styles'

interface TCoachmarkWrapperProps extends ViewProps {}

export function CoachmarkWrapper({
  children,
  ...rest
}: TCoachmarkWrapperProps) {
  return <Comp.Wrapper {...rest}>{children}</Comp.Wrapper>
}
